function createShorthands(shorthands) {
  return Object.freeze(shorthands);
}
export {
  createShorthands
};
